import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { ExtendedThalamosUser } from "@thalamos/aspire-common";
import {
  isCqcUserSession,
  isGuestUserSession,
  isIndependentUserSession,
  isSoadUserSession,
} from "@thalamos/aspire-common";

import { routeFns } from "../../routePaths.js";
import type { WorkMode } from "./types.js";
import { Banner, BannerList } from "~/components/design-system/index.js";

export default function NoResultsBanners({
  mode,
  noSearchOrFilterResults,
  user,
}: {
  mode: WorkMode;
  noSearchOrFilterResults: boolean;
  user: ExtendedThalamosUser;
}) {
  const isSoad = isSoadUserSession(user);
  const isCqC = isCqcUserSession(user);
  const isGuest = isGuestUserSession(user);
  const isSoadOrCqc = isSoad || isCqC;
  const isPdsEnabled =
    user?.sessionOrganisationConfiguration?.pdsEnabled ?? false;
  const isIndependentWithoutPds =
    isIndependentUserSession(user) && !isPdsEnabled;

  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: "2em",
          mt: 2,
        }}
      >
        No Results
      </Box>
      {!isSoadOrCqc && !isGuest && (
        <Box>
          {mode === "caseload" && (
            <>
              {noSearchOrFilterResults ? (
                <>
                  {isIndependentWithoutPds ? (
                    <Banner
                      title={t("pages.caseload.noResultsWhenSearchBanner")}
                      bannerType={BannerList.WARNING}
                      iconOff
                      onRightButton={() => {
                        navigate(routeFns.patientSearch());
                      }}
                      rightButtonLabel={t("buttonLabels.createPatient")}
                    ></Banner>
                  ) : (
                    <Banner
                      title={t("pages.caseload.noResultsSearchBannerTeam")}
                      bannerType={BannerList.WARNING}
                      iconOff
                      onRightButton={() => {
                        navigate(routeFns.patientSearch());
                      }}
                      rightButtonLabel={t("buttonLabels.searchPatient")}
                    ></Banner>
                  )}
                </>
              ) : (
                <>
                  {isIndependentWithoutPds ? (
                    <Banner
                      title={t("pages.caseload.noResultsSearchBanner")}
                      bannerType={BannerList.WARNING}
                      iconOff
                      onRightButton={() => {
                        navigate(routeFns.patientCreate());
                      }}
                      rightButtonLabel={t("buttonLabels.createPatient")}
                    ></Banner>
                  ) : (
                    <Banner
                      title={t("pages.caseload.noResultsWhenSearchBannerTeam")}
                      bannerType={BannerList.WARNING}
                      iconOff
                      onRightButton={() => {
                        navigate(routeFns.patientSearch());
                      }}
                      rightButtonLabel={t("buttonLabels.searchPatient")}
                    ></Banner>
                  )}
                </>
              )}
            </>
          )}
        </Box>
      )}
    </>
  );
}
